import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {UserProfileForm} from "@models";


@Component({
    selector: 'app-profile-view',
    imports: [],
    templateUrl: './profile-view.component.html',
    styleUrls: ['./profile-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileViewComponent {
  @Input() user!: UserProfileForm

  constructor() {
  }

}
